import { UICityHoverActionController } from '../ui_game_hover_actions/UICityHoverActionController.ts';
import { UIRoadHoverActionController } from '../ui_game_hover_actions/UIRoadHoverActionController.ts';
import { UISettlementHoverActionController } from '../ui_game_hover_actions/UISettlementHoverActionController.ts';
export var UIGameActionButtonPositions = /*#__PURE__*/ function(UIGameActionButtonPositions) {
    UIGameActionButtonPositions[UIGameActionButtonPositions["Trade"] = 0] = "Trade";
    UIGameActionButtonPositions[UIGameActionButtonPositions["DevCard"] = 1] = "DevCard";
    UIGameActionButtonPositions[UIGameActionButtonPositions["CityImprovementMultiButtonMobile"] = 2] = "CityImprovementMultiButtonMobile";
    UIGameActionButtonPositions[UIGameActionButtonPositions["CityWall"] = 3] = "CityWall";
    UIGameActionButtonPositions[UIGameActionButtonPositions["Road"] = 4] = "Road";
    UIGameActionButtonPositions[UIGameActionButtonPositions["Settlement"] = 5] = "Settlement";
    UIGameActionButtonPositions[UIGameActionButtonPositions["City"] = 6] = "City";
    UIGameActionButtonPositions[UIGameActionButtonPositions["EndTurn"] = 7] = "EndTurn";
    UIGameActionButtonPositions[UIGameActionButtonPositions["BuildShip"] = 8] = "BuildShip";
    UIGameActionButtonPositions[UIGameActionButtonPositions["MoveShip"] = 9] = "MoveShip";
    UIGameActionButtonPositions[UIGameActionButtonPositions["KnightMultiButton"] = 10] = "KnightMultiButton";
    UIGameActionButtonPositions[UIGameActionButtonPositions["CityImprovementMultiButtonWeb"] = 11] = "CityImprovementMultiButtonWeb";
    return UIGameActionButtonPositions;
}({});
export class UIGameActionsController {
    initializeHoverActions(settlementState, cityState, roadState) {
        if (roadState) new UIRoadHoverActionController(this.uiGameManager, roadState);
        if (settlementState) new UISettlementHoverActionController(this.uiGameManager, settlementState);
        if (cityState) new UICityHoverActionController(this.uiGameManager, cityState);
    }
    constructor(uiGameManager, settlementState, cityState, roadState){
        this.uiGameManager = uiGameManager;
        if (this.uiGameManager.gameController.isPlayerSpectator) return;
        if (this.uiGameManager.gameController.isReplay) return;
        this.initializeHoverActions(settlementState, cityState, roadState);
    }
}
